/**
 * Routes that should be accessible without authentication
 */
export const STATIC_ROUTES: Record<string, boolean> = {
  '/fairdee-form': true,
  '/line-login': true,
};
